<template>
  <div class="swiper">
    <div @mouseleave="leave" @mouseenter="enter">
      <swiper ref="mySwiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) in clist"
                      :key="index">

          <div class="rn-gallery icon-center" data-aos="fade-up">
            <img :src="item.src" class="radius-small"/>


            <div class="video-icon">
              <Button variant-button-class="rounded-player sm-size"
                      :is-link="false"
                      @btnClick="handleImage(index)">
                <span><Icon name="search"/></span>
              </Button>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div @mouseenter="enter" @mouseleave="leave" >
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>

      <CoolLightBox
          :useZoomBar="true"
          :items="clist"
          :index="imageIndex"
          @close="handleClose">
      </CoolLightBox>
    </div>




  </div>
</template>

<script>
import Button from '../button/Button'
import Icon from '../../icon/Icon'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: "Swipers",
  components: {
    Swiper,
    SwiperSlide,
    Icon,Button
  },
  props:{
    clist:{
      type: Array,
      default:()=>[]
    }
  },
  data () {
    return {
      imageIndex: null,
      swiperOption: {
        // 衔接滑动
        loop: true,
        // 自动滑动
        autoplay: {
          delay: 2000,
          // 如果设置为true，当切换到最后一个slide时停止自动切换。
          stopOnLastSlide: false,
          // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
          disableOnInteraction: false
        },
        // 切换效果 "coverflow"（3d流）
        effect: 'coverflow',
        // 设置slider容器能够同时显示的slides数量
        slidesPerView: 3,
        // 居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
        centeredSlides: true,
        // 设置为true则点击slide会过渡到这个slide。
        slideToClickedSlide: true,
        coverflowEffect: {
          // slide做3d旋转时Y轴的旋转角度
          rotate: 0,
          // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
          stretch: 0,
          // slide的位置深度。值越大z轴距离越远，看起来越小。
          depth: 60,
          // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
          modifier: 5,
          // 是否开启slide阴影
          slideShadows: true
        },
        // 使用前进后退按钮来控制Swiper切换。
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        //开启鼠标滚轮控制Swiper切换
        //mousewheel: true

      },
    }
  },
  computed: {
    mySwiper () {
      // mySwiper 是要绑定到标签中的ref属性
      return this.$refs.mySwiper.$swiper
    }
  },
  methods:{
    enter () {
      this.mySwiper.autoplay.stop()
    },
    leave () {
      this.mySwiper.autoplay.start()
    },
    handleImage(index){
        this.imageIndex = index;
    },
    handleClose(){
      this.imageIndex = null;
    }

  }
}
</script>

<style scoped lang="scss" >
.swiper{

  margin: 0 auto;

}
.swiper-button-prev{
  margin-top: 150px;
}
.swiper-button-next{
  margin-top: 150px;
}


</style>